import { Box, Modal } from '@mui/material';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { toast } from 'react-toastify';

import ButtonCloseModal from '@/components/ui/Button/ButtonCloseModal';
import BaseSelect from '@/components/ui/Select/BaseSelect';
import Loader from '@/components/ui/Loader/Loader';

import usePatch from '@/hooks/usePatch';
import ModalStyle from '@/constants/ModalStyle';

const schema = yup.object().shape({
	version: yup.string().required(),
	status: yup.string().required(),
});

export default function Category(props) {
	const { open, onClose, data, onCallback } = props;

	const projectStatus = useSelector((state) => state.content.projectStatus);

	const isEdit = !!data;

	const { handleSubmit, control, reset, watch } = useForm({
		resolver: yupResolver(schema),
		defaultValues: {
			status: data?.status || '',
			version: data?.productversion || '',
		},
	});

	const handleClose = () => {
		reset();
		onClose();
	};

	const versions = data?.version_list;
	const nVer = watch('version');
	const sVerId = versions?.length ? versions.find((v) => v.productversion === nVer)?.productid || null : data.productid;

	const { mutate: updateProject, isPending } = usePatch({
		url: `component/${sVerId}`,
		method: 'patch',
		type: 'form-data',
		callback: (res) => {
			if (res.status === 200 && res.data) {
				toast.success(`project updated successfully`);
				reset();
				onCallback();
			}
		},
		onError: () => {},
		showError: true,
	});

	const onSubmit = (data) => {
		const fData = new FormData();
		fData.append('status', data.status);
		updateProject(fData);
	};

	const isProj = useMemo(
		() => +data?.productprefixid === 12 || data?.productprefix_detail[0].productprefix.toLowerCase().includes('proj'),
		[data]
	);

	return (
		<Modal open={open} onClose={handleClose} aria-labelledby='modal-notes' aria-describedby='modal-notes' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25%' }} className='flex flex-col gap-4 w-[90%] md:w-[380px]'>
				<span className='text-2xl modal-title'>{isEdit ? `Edit (${data.productcodenumber})` : 'Legg til ny Status'}</span>
				<ButtonCloseModal onClose={handleClose} />

				<hr />

				<form onSubmit={handleSubmit(onSubmit)} className='flex flex-col w-full gap-4'>
					{isPending && <Loader />}
					<div className='flex gap-4'>
						<BaseSelect
							control={control}
							name='version'
							label='Versjon'
							errors
							data={versions || []}
							config={{
								styles: {},
								classes: '',
								disabled: !versions.length,
								keyVal: 'productversion',
								keyName: 'productname',
								keyLabel: 'productversion',
								isRequired: true,
							}}
							required
							size='small'
						/>
						<BaseSelect
							control={control}
							name='status'
							label='Status'
							errors
							data={projectStatus}
							required
							config={{
								styles: {},
								classes: '',
								keyVal: 'id_status',
								keyName: isProj ? 'desc' : 'label',
								keyLabel: isProj ? 'desc' : 'label',
								isRequired: true,
							}}
							size='small'
						/>
					</div>
					<hr />

					<div className='flex gap-4 ml-auto'>
						<button className='px-3 py-2 text-white rounded-md btn bg-primary' type='submit'>
							{isEdit ? 'Oppdater' : 'Legg til'}
						</button>
					</div>
				</form>
			</Box>
		</Modal>
	);
}
